// extracted by mini-css-extract-plugin
export var actionButton = "_yu-2";
export var card = "_yu-0";
export var disambiguationList = "_yu-3";
export var errorCard = "_yu-4";
export var row = "_yu-1";